import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataForm } from '@libs/shared/static-data/Data-form.static';
import { NgxMaskService } from 'ngx-mask';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupType } from '@libs/types/group.type';
import { environment } from '@libs/environment';
import { SendEventHelper } from '@libs/helpers/send-event.helper';
import { SESSION_STORAGE } from '@libs/shared/injections/window';
import { IFormControls } from '@libs/models/models';

@Component({
  selector: 'app-auth-phone-edit-modal',
  templateUrl: `./templates/${environment.group}/page.html`,
  styleUrls: ['./auth-phone-edit-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthPhoneEditModalComponent implements OnInit {
  public form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { phoneNumber: number; group: GroupType },
    public dialogRef: MatDialogRef<AuthPhoneEditModalComponent>,
    private maskService: NgxMaskService,
    private eventHelper: SendEventHelper,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {}

  get f(): IFormControls {
    return this.form.controls;
  }

  public get phoneNumber(): string {
    return this.maskService.applyMask(this.data.phoneNumber.toString(), '+00(000) 000 00 00');
  }

  public ngOnInit(): void {
    this.activateForm();
  }

  public activateForm(): void {
    this.form = DataForm.getLoginFormGroup();
  }

  public updatePhone(): void {
    this.form.get('phone').markAsTouched();
    if (this.form.invalid) {
      return;
    }
    const newPhone = this.form.value.phone;
    this.eventHelper.send(`change phone form ${this.data.phoneNumber} to ${newPhone}`, this.data.phoneNumber);
    this.sessionStorage.setItem('phone', newPhone);
    this.dialogRef.close(newPhone);
  }
}
